import React from "react";
import { withRouter } from "react-router-dom";
import TamaraReturnBase from "./TamaraReturnBase";

const TamaraSuccess = (props) => {
  return (
    <TamaraReturnBase
      iconClass="fa-check-circle text-success"
      title="تم الدفع بنجاح"
      message="شكراً لك. تم تأكيد العملية وسنقوم بإرسال طلبك قريباً"
      buttonText="عرض الطلبات"
      buttonAction={() => props.history.push("/course/content")}
    />
  );
};

export default withRouter(TamaraSuccess);
